export const ch = {
    lang: 'ch',
    /* Výběr jazyka */
    lang_title: "Vyberte jazyk",
    /* Dates */
    dates_day_ago: "včera",
    dates_day_now: "dnes",
    dates_day_sun: "ne",
    dates_day_mon: "po",
    dates_day_tue: "út",
    dates_day_wed: "st",
    dates_day_thu: "čt",
    dates_day_fri: "pá",
    dates_day_sat: "so",
    dates_month_1: "Leden",
    dates_month_2: "Únor",
    dates_month_3: "Březen",
    dates_month_4: "Duben",
    dates_month_5: "Květen",
    dates_month_6: "Červen",
    dates_month_7: "Červenec",
    dates_month_8: "Srpen",
    dates_month_9: "Září",
    dates_month_10: "Říjen",
    dates_month_11: "Listopad",
    dates_month_12: "Prosinec",
    dates_month_pril_1: "Leden",
    dates_month_pril_2: "Únor",
    dates_month_pril_3: "Březen",
    dates_month_pril_4: "Duben",
    dates_month_pril_5: "Květen",
    dates_month_pril_6: "Červen",
    dates_month_pril_7: "Červenec",
    dates_month_pril_8: "Srpen",
    dates_month_pril_9: "Září",
    dates_month_pril_10: "Říjen",
    dates_month_pril_11: "Listopad",
    dates_month_pril_12: "Prosinec",
    /* LoginPage */
    //Přihlášení
    login_alert_user_exist: "Uživatel s tímto e-mailem existuje.",
    login_alert_user_miss: "Uživatel nebyl nalezen",
    login_alert_wrong_filling: "Vyplňte uživatelské jméno nebo heslo",
    login_alert_pass_send: "Heslo bylo odesláno na váš e-mail",
    login_alert_server_not_available: "Server je dočasně nedostupný",
    login_alert_fill_fields: "Vyplňte všechny řádky",
    login_alert_fill_name: "Vyplňte pole pro jméno",
    login_alert_fill_lastname: "Vyplňte pole příjmení",
    login_alert_fill_email: "Vyplňte pole email",
    login_alert_fill_street: "Doplňte ulici",
    login_alert_fill_city: "Vyplňte pole města",
    login_alert_fill_password: "Vyplňte pole pro heslo",
    login_alert_fill_code: "Pole indexu je prázdné",

    //alert message end
    login_enter_profile: "Přihlášení k uživatelskému účtu",
    login_reg: "Přihlásit",
    login_enter: "Vstup",
    login_my_order: "Moje objednávka",
    login_btn_facebook_enter: "Přihlášení přes facebook",
    login_or: "nebo",
    login_email: "E-mail",
    login_pass: "Heslo",
    login_enter_email: "Přihlašovací Е-mail",
    login_forgot_pass: "Zapomněli jste heslo?",
    login_btn_reg: "Registrovat",
    login_btn_entered: "Přihlásit",
    login_btn_cancel: "Storno",
    login_btn_pass_send: "Poslat heslo",
    // Registrace
    reg_user_reg: "Registrace uživatele",
    reg_individual_face: "Fyzická osoba",
    reg_entity_face: "Právnická osoba",
    reg_second_name: "Příjmení",
    reg_name: "Jméno",
    reg_organization_name: "Název společnosti:",
    reg_INN: "IČ:",
    reg_entity_adress: "Fakturační adresa:",
    reg_email: "E-mail:",
    reg_pass: "Heslo:",
    reg_again_pass: "Potvrďte heslo:",
    reg_again_pass_wrong: "* Neshoda hesla",
    reg_question_about_find: "Jak jste se o nás dozvěděl/a?",
    reg_inet_AD: "Internetová reklama",
    reg_recommend: "Doporučení",
    reg_over: "Jiné",
    reg_delivery_info: "informace o doručení",
    reg_info_task: "Pro dokončení objednávky doplňte prosím dodácí údaje.",
    reg_phone: "Кontaktní telefon:",
    reg_delivery_data: "Datum prvního dodání:",
    reg_street: "Ulice a popisné číslo:",
    reg_city: "Město:",
    reg_index: "PSČ:",
    reg_commentary: "Poznámka:",
    reg_dop_info: "Další informace o doručení (číslo bytu, patro,  další komentář pro kurýra)",
    reg_agreement_1: "Potvrzení registrace souhlasím se",
    reg_agreement_2: "Zpracování osobních údajů",
    reg_agreement_3: "Obchodní podmínky",

    reg_exclude_1: "Maso",
    reg_exclude_2: "Ryby a mořské plody",
    reg_exclude_2: "Ořechy",
    reg_exclude_3: "Mléčné výrobky (bez laktózy)",
    reg_exclude_4: "Jahody",
    reg_exclude_5: "Houby",
    reg_exclude_6: "Jiné",
    reg_exclude_text: "Vyloučit ze stravy",
    reg_exclude_text2: "Žádné vyloučení",
    
    reg_exclude_about: "* Výměna jednoho produktu - zdarma, výměna každého následujícího produktu - 20 Kč / jeden produkt/ den. Výměna mléčných výrobků - 40 Kč / den.</br> Pokud jste označili produkt, který není uveden v seznamu, možnost jeho vyloučení bude potvrzena manažerem po obdržení objednávky. </br> Cena za výměnu bude přidána k ceně programu po potvrzení objednávky naším manažerem. Finalní faktura bude odeslána do 2 pracovních dnů.",

    reg_btn_reg: "Registrace",
    reg_btn_cancel: "Zpátky",
    reg_and: "a",
    /* BonusPage */
    bonus_alert_copyed: "Zkopírováno",
    bonus_header_1: "Profil iKitchen",
    bonus_header_2: "Bonusy",
    bonus_my_bonus: "Moje bonusy:",
    bonus_barter: "1 bonus = 1 koruna",
    bonus_rule_0: "Pravidla bonusového systému",
    bonus_rule_1: "Nelze vytvořit falešné účty.",
    bonus_rule_2: "Bonusy lze použit na úhradu maximálně 20% celkové hodnoty objednávky. Toto procento se může líšit v závislosti na pravidlech konkrétní marketingové kampaně.",
    bonus_rule_3: "",
    bonus_rule_4: "Sdílejte propagační kód se svými přáteli a dostávejte bonusy!",
    bonus_promocode: "Zkopírujte promo kód tady:",
    bonus_btn_promocode: "Zkopírujte promo kód",
    bonus_promocode_rule: "Doba platnosti tohoto promo kódu je 30 dní",
    bonus_info: "Informace o bonusových pravidlech",
    bonus_info_cashback: "Cashback:",
    bonus_info_text1: "Při zakoupení jakéhokoliv programu dostanete cashback ve výši 2% hodnoty objednávky ve formě kreditů iKitchen.",
    bonus_info_promocode: "Promo kód:",
    bonus_info_text2: "Ve vašem osobním profilu je vygenerován propagační kód, který lze poskytnout známým a přátelům. Poté, co přátelé provedou objednávku a zaplatí za ni s využitím propagačního kódu, na Vaš účet budou připsány kredity ve výši 1% z ceny objednávky. Zároveň bude stejná částka připsána osobě, která objednávku provedla, a zaplatila za ni. Propagační kód platí jenom pro první objednávku. Může ho použit více osob, ale kód lze uplatnit jenom u první objednávky každého nového účtu.",
    /* CartPage */
    cart_alert_error: "Chyba ve vytvoření objednávky",
    cart_basket: "Košík iKitchen",
    cart_new_order: "Můj košík",
    cart_dont_paid: "Nezaplaceno",
    cart_on_day1: "na",
    cart_on_day2: "dny",
    cart_to_paid: "K zaplacení",
    cart_btn_paid: "Dokončit objednávku",
    cart_btn_paid2: "Zaplatit objednávku",
    cart_currency: "Kč",
    cart_btn_cancel_order: "Vyprázdnit košík",
    cart_info: "ve vyznačených dnech můžete přizpůsobit nabídku.",
    cart_menu: "Jídelníček",
    cart_delivery: "Doručení",
    cart_summary_in: "Celkem ",
    cart_kkal: "kCal",
    cart_B: "Bílkoviny",
    cart_J: "Tuky",
    cart_U: "Sacharidy",
    cart_drink: "nápoj",
    cart_gramm: "g",
    cart_breakfast: "Snídaně",
    cart_delivery_data: "Datum prvního doručení ",
    cart_delivery_info_1: "Rozvoz se provádí v neděli, úterý a ve čtvrtek, doručujeme jídlo na 2 dny.",
    cart_delivery_info_2: "Začátek stravování od pondělí - objednávka do pátku",
    cart_delivery_info_3: "Začátek stravování od středu - objednávka do neděle",
    cart_delivery_info_4: "Začátek stravování od pátku - objednávka do úterý",
    cart_delivery_from_day: "Denní doručení ",
    cart_delivery_info_5: "Fotografie jídel na webových stránkách jsou možnou variantou servírování. Vzhled jídla se může lišit od fotografií na webu. Vyhrazujeme si právo výměny některých ingredientů dle aktuální dostupnosti",
    cart_empty_backet: "Košík je prázdný",
    cart_btn_go_to_menu: "Přejít k jídelníčku",
    /* HomePage */
    home_kkal: "kCal",
    home_currency: "Kč",
    /* About */
    home_about_header_1: "Zdravé a chutné jídlo",
    home_about_header_2: "přírodní ingredience",
    home_about_text_1: "Chutná jako v restauraci",
    home_about_text_2: "Jídlo připravené prémiovými profesionálními kuchaří",
    home_about_text_3: "Vyvážená strava",
    home_about_text_4: "Pestrý a vyvážený jídelníček. Přidáváme hodně zeleniny a ovoce pro posílení zdraví",
    home_about_text_5: "Bez lepku",
    home_about_text_6: "Všechny naše programy se připravují z bezlepkových potravin, bez cukru, konzervantů a barviv",
    home_about_text_7: "Stylová prezentace",
    home_about_text_8: "Naše jídla potěší nejenom Vaše chuťové buňky, ale i oko",
    home_about_text_9: "Nové menu každý den",
    home_about_text_10: "Hlavní jídla se neopakují během 4 týdnů",
    home_about_text_11: "Velký výběr programů",
    home_about_text_12: "Balance, Vege, Low Carb, Anti-age",
    home_about_text_13: "Moderní výroba",
    home_about_text_14: "Používáme současné inteligentní technologie výroby pokrmů pro nejlepší výsledek",
    home_about_text_15: "Osobní profil",
    home_about_text_16: "Jednoduchý uživatelský účet s přehledem jídelníčku a nutričních hodnot",
    /* Calculate */
    home_calculate_header_1: "Vyberte si ",
    home_calculate_header_2: "program, který Vám nejlépe vyhovuje",
    home_calculate_subtitle: "Stravovácí program pro Vás",
    home_calculate_btn: "K vybranému programu",
    /* Food Menu */
    home_food_menu_header_1: "Vyvážené zdravé stravování",
    home_food_menu_header_2: "Váše jídlo již na Vás čeká",
    home_food_menu_in: "Popis",
    home_food_menu_day: "Den v týdnu",
    home_food_menu_text_0: "PONDĚLÍ",
    home_food_menu_text_1: "Chod",
    home_food_menu_text_2: "SNÍDANĚ",
    home_food_menu_text_3: "Snídaně",
    home_food_menu_text_4: "Svačina",
    home_food_menu_text_5: "Oběd",
    home_food_menu_text_6: "Dezert",
    home_food_menu_text_7: "Večeře",
    home_food_menu_option_stop: "Pozastavit",
    
    home_food_menu_option_1: "Délka programu",
    home_food_menu_option_2: "Počet porcí",
    home_food_menu_option_3: "Počet osob",
    home_food_menu_option_4: "Délka týdne",
    home_food_menu_option_5: "Platba",
    home_food_menu_option_5_item_1: "Placeno",
    home_food_menu_option_5_item_2: "Nezaplaceno",
    home_food_menu_option_6: "Počet dní",

    home_food_menu_option_4_item_1: "Po - So",
    home_food_menu_option_4_item_2: "Po - Pá",

    home_food_menu_option_1_item_1: "na 4 dny",
    home_food_menu_option_1_item_2: "na 6 dnů",
    home_food_menu_option_1_item_3: "na 12 dní",
    home_food_menu_option_1_item_4: "na 24 dnů",

    home_food_menu_option_1_item_5: "na 5 dnů",
    home_food_menu_option_1_item_6: "na 10 dnů",
    home_food_menu_option_1_item_7: "na 15 dnů",
    home_food_menu_option_1_item_8: "na 20 dnů",

    home_food_menu_option_2_item_1: "všechny porce",
    home_food_menu_option_2_item_2: "Snídaně + Oběd",
    home_food_menu_option_2_item_3: "Snídaně + Večeře",
    home_food_menu_option_2_item_4: "Oběd + Svačina",
    home_food_menu_option_2_item_5: "Oběd + Večeře",
    home_food_menu_option_2_item_6: "Snídaně + Oběd + Večeře",

    home_food_menu_price: "Cena",
    home_food_menu_price_text_1: "Váše úspora činí ",
    home_food_menu_price_text_2: "bude vráceno na Váš uživatelský účet",
    home_food_menu_btn: "Dokončit objednávku",
    /* App */
    home_app_header_1: "iKitchen App",
    home_app_header_2: "Stáhněte si aplikaci",
    home_app_text_1: "Objednání, přehled jídelníčku a nutričních hodnot, provedení změn - nyní ve Vašem mobilu. Jednoduché objednání z pohodlí domova nebo kanceláře. Již brzy ke stažení! ",
    home_app_text_2: "Stáhněte si aplikaci",
    home_map_header: "Mapa rozvozu",
    home_reviews_header: "Reference",
    home_faqs_header: "FAQ",
    home_inst_header_1: "Instagram",
    home_inst_header_2: "Co říkají naše klienti",
    /* plansPage */
    plans_alert_pay_1: "Budete muset zaplatit navíc",
    plans_alert_pay_2: "kurýrem pro jídlo",
    plans_alert_save_err: "Nelze uložit bez uvedení ulice a čísla domu",
    plans_alert_error: "Chyba aktualizace",
    plans_transfer_title: "Přenos programu",
    plans_transfer_title_description: "Vyberte nový den zahájení programu",
    plans_pay_title_paid: "Příplatek",
    plans_pay_subtitle_paid: "Doplněk pro výměnu jídla v programu",
    plans_not_paid: "Nezaplaceno",
    plans_not_paid_from: "od",
    plans_not_paid_for: "do",
    plans_header: "Profil iKitchen",
    plans_title: "Aktivní objednané programy",
    plans_prolongation_title: "Automatické obnovení plánu",
    plans_prolongation_btn: "Automatické obnovení",
    plans_replay: "Opakovat",
    plans_li_1: "Jídelníček",
    plans_li_2: "Doručení",
    plans_li_3: "Hodnocení",
    plans_info: "Ve dnech, které mají tot označení můžete nabídku dodatečně přizpůsobit.",
    plans_kkal: "kCal",
    plans_summary_in: "Celkem ",
    plans_B: "Bílkoviny",
    plans_J: "Tuky",
    plans_U: "Sacharidy",
    plans_drink: "nápoj",
    plans_currency: "Kč",
    plans_gramm: "g",
    plans_dinner: "Snídaně",
    plans_text: "Fotografie jídel na webových stránkách jsou možnou variantou servírování. Vzhled jídla se může lišit od fotografií na webu. Vyhrazujeme si právo výměny některých ingredientů dle aktuální dostupnosti.",
    plans_empty_orders: "Košík je prazdný",
    plans_btn_go_to_menu: "Přejít k vybranému programu",
    /*ProfilePage*/
    profile_header: "Profil iKitchen",
    profile_my_data: "Moje údaje",
    profile_second_name: "Příjmení",
    profile_name: "Jméno",
    profile_organization_name: "Název společnosti",
    profile_INN: "IČ",
    profile_entity_adress: "Fakturační adresa",
    profile_email: "E-mail",
    profile_change_pass: "Změnit heslo",
    profile_old_pass: "Staré heslo",
    profile_new_pass: "Nové heslo",
    profile_again_pass: "Potvrdit heslo",
    profile_pass_6_symbol: "nejméně 6 znaků",
    profile_again_pass_wrong: "* Hesla se neshodují",
    profile_delivery_info: "Informace o doručení",
    profile_info_task: "Pro dokončení objednávky doplňte prosím dodácí údaje.",
    profile_phone: "Telefon",
    profile_street: "Ulice a čislo popisné",
    profile_city: "Město",
    profile_index: "PSČ",
    profile_commentary: "Poznámka",
    profile_dop_info: "Další informace o doručení (číslo bytu, patro,  další komentář pro kurýra)",
    profile_btn_save: "Uložit",
    profile_agreement: "Dohoda o zpracování osobních údajů",
    profile_btn_exit: "Odhlásit",
    /*SubscribePage*/
    subscribe_alert: "V případě zájmu o přihlášení, kontaktujte správce",
    subscribe_header: "Profil iKitchen ",
    subscribe_question: "Jaké výhody mi přináší předplatné?",
    subscribe_my_subscribe: "Moje předplatné",
    subscribe_miss: "Nemáte aktivní předplatné. V případě zájmu o předplatní, připojte níže uvedenou kartu",
    subscribe_btn_subscribe_deal: "Objednat předplatné",
    subscribe_card_info: "Informace o kartě",
    subscribe_card_num: "Číslo karty",
    subscribe_btn_change_card: "Změnit kartu",
    subscribe_discount_info: "Máte od nás slevu",
    subscribe_info_1: "Objednání programu na 12 dní, 18 dní nebo měsíc",
    subscribe_info_2: "Sleva x% Kč při okamžitou platbě",
    subscribe_info_3: "Schopnost zaplatit program okamžitě, úplně",
    subscribe_info_4: "Nebo zaplatit měsíční předplatné jednou týdně v určitý den",
    subscribe_faq_header: "Jak funguje předplatné?",
    subscribe_faq_text_1: "Kolik dní činí předplatné?",
    subscribe_faq_text_2: "12 dní, 18 dní nebo měsíc",
    subscribe_faq_text_3: "Jak zaplatím za předplatné?",
    subscribe_faq_text_4: "Kartou prostřednictvím platebního systému",
    subscribe_faq_text_5: "Jak se účtuje platba?",
    subscribe_faq_text_6: "Jednou týdně (v sobotu / neděli před začátkem nového týdne programu) se prostředky automaticky odečtou z Vaší karty.",
    subscribe_faq_text_7: "Co když na kartě nemám peníze?",
    subscribe_faq_text_8: "Pokud zaplacení neproběhne v sobotu, kurýr požáduje o zaplacení objednávky při dodání v neděli. Můžete zaplatit hotevě nebo platební kartou.",
    /*UI Module*/
    //uibasketcard
    basketcard_text_1: "Textový popis",
    basketcard_text_2: " Snídaně + Oběd, na 14 dnů",
    basketcard_currency: "Kč",
    //UiCalculator
    calculator_gender: "Pohlaví",
    calculator_woman: "Žena",
    calculator_man: "Muž",
    calculator_age: " Věk",
    calculator_height: "Výška",
    calculator_sm: "cm",
    calculator_weight: "Váha",
    calculator_kg: "kg",
    calculator_back_step: "zpátky",
    calculator_next_step: "Další krok",
    calculator_done: "Hotovo",
    calculator_header_1: "Jak jste aktivní",
    calculator_li_1_item_1: "Sedavy způsob života",
    calculator_li_1_item_2: "Střední aktivita (1x-2x týdně)",
    calculator_li_1_item_3: "Zvýšená aktivita (3x-5x týdně)",
    calculator_li_1_item_4: "Velmi vysoká aktivita- sportovce",
    calculator_header_2: "Stravovácí preference",
    calculator_li_2_item_1: "Vyvážené jídlo",
    calculator_li_2_item_2: "Vegetariánské jídlo",
    calculator_li_2_item_3: "hypoalergenní (vyloučeno: lepek, ořechy, laktóza, vejce vyjma) ",
    calculator_li_2_item_4: "Low Carb (pro rychlé hubnutí)",
    calculator_li_2_item_5: "paleo diet",
    calculator_li_2_item_6: "Jídlo proti stárnutí",
    calculator_li_2_item_7: "zvýšení imunity",
    calculator_header_3: "O jaké výsledky usilujete",
    calculator_li_3_item_1: "Zhubnout",
    calculator_li_3_item_2: "Udržet kondici",
    calculator_li_3_item_3: "Nabrat svalovou hmotu",
    //UiDeliveryItem
    delivery_item_delivery: "Doručení ",
    delivery_item_day: "ráno",
    delivery_item_evening: "večer",
    delivery_item_adress: "Dodací adresa",
    delivery_item_btn_change: "Upravit",
    delivery_item_wishes: "Individuální přání",
    //UiPlanCard
    plan_card_btn_add: "Přidat",
    plan_card_btn_delete: "Smazat",
    plan_card_btn_swap: "Výměnit",
    plan_card_composition: "Složení",
    plan_card_in_100_gramm: "na porci",
    plan_card_kkal: "kCal",
    plan_card_B: "Bílkoviny",
    plan_card_J: "Tuky",
    plan_card_U: "Sacharidy",
    plan_card_btn_pick: "Vybrat",
    plan_card_currency: "Kč",
    //UiRating
    rating_text: "již hodnocené",
    //UiPie
    pie_kkal: "kCal",
    pie_gramm: "g",
    pie_B: "B",
    pie_J: "T",
    pie_U: "S",
    //UiFooter
    footer_logo_text: "iKitchen",
    footer_adress: "Adresa",
    footer_adress_text_0: "iCatering s.r.o.",
    footer_adress_text_1: "IČ: 09092684",
    footer_adress_text_2: "DIČ: CZ09092684",
    footer_adress_text_3: "Evropská 157a, Praha 6",
    footer_adress_text_4: "info@ikitchen.cz",
    footer_phone: "Telefon",
    footer_phone_num: "+420 222 744 130",
    footer_brend: "iKitchen",
    footer_ARR: "Všechná práva vyhrazená - 2020",
    //UiSwitch
    switch_evening: "večer ",
    switch_day: "ráno",
    // UiHeader
    header_lang_ru: "Русский",
    header_lang_ch: "Čeština",
    header_lang_en: "English",
    header_about: "O nás",
    header_calc: "Kalkulačka",
    header_faq: "Otázky a odpovědi",
    header_contact: "Kontakty",
    header_home: "Domov",
    header_profile: "Můj profil",
    header_basket: "Můj košík",
    header_plans: "Aktivní programy",
    header_subscribe: "Předplatné",
    header_preferences: "Moje preference",
    header_bonus: "Bonusy",
    header_btn_menu: "Jídelníček",
    //UiModalChangeAdress
    modal_change_adress_street: "Ulice, číslo popisné",
    modal_change_adress_city: "Město",
    modal_change_adress_index: "PSČ",
    modal_change_adress_wishes: "Poznámka",
    modal_change_adress_time: "Čas",
    modal_change_adress_btn_save: "Uložit",
    //UiMenuProfile
    menu_profile_profile: "Můj profil",
    menu_profile_basket: "Můj košík",
    menu_profile_plans: "Aktivní programy",
    menu_profile_subscribe: "Předplatné",
    menu_profile_preferences: "Moje preference",
    menu_profile_bonus: "Bonusy",
    menu_profile_history: "Historie nákupů",
    //UiModalPay
    modal_pay_on: "na",
    modal_pay_days: "dny",
    modal_pay_currency: "Kč",
    modal_pay_bonus: "Dostupné bonusy",
    modal_pay_pay_bonus: "Zaplatit bonusy",
    modal_pay_promocode: "Propagační kód",
    modal_pay_promocode_not_valid: "Promo kód není platný",
    modal_pay_to_pay: "Celkem k úhradě",
    modal_pay_NDS: "Včetně DPH",
    modal_pay_pay_card: "Platit kartou",
    modal_pay_placeholder: "Jméno držitele platební karty",
    modal_pay_cash_to_courier: "V hotovosti při převzetí kurýrovi ",
    modal_pay_pay_card_to_courier: "Platba kartou při převzetí kurýrovi",
    modal_pay_bank_transfer: "Bankovní převod",
    modal_pay_btn_pay: "OBJEDNAT s povinností platby",
    modal_pay_btn_order: "OBJEDNAT s povinností platby",
    //UiTopSlider
    home_slider_title_1: "Zdravé a chutné jídlo na každý den",
    home_slider_text_1: "Žádné nakupování, žádné vaření, žádné počty kalorií, žadné starostí ",
    home_slider_title_2: "iKitchen – jídlo, které posiluje imunitu, zlepšuje zdraví a prodlužuje mládí.",
    home_slider_text_2: "Zdravě a chutně",
    home_slider_title_3: "Zdravé a chutné jídlo na každý den",
    home_slider_text_3: "Žádné nakupování, žádné vaření, žádné počty kalorií, žadné starostí",
    home_slider_btn_more: "Další informace",
    home_slider_btn_plan: "Vyberte si program",
    home_slider_btn_deli: "Mapa rozvozu",
    //UiModalMenu
    modal_menu_dinner: "Snídaně",
    modal_menu_kkal: "kCal",
    modal_menu_gramm: "g",
    modal_menu_kkal: "Vyměňit druhou snídaně v úterý",
    //UiFaq
    faq_slimming: "Skladování a konzumace",
    faq_products: "Jídlo",
    faq_rates: "O nás",
    faq_pay: "Doručení a platba",
    faq_Storage: "Objednávka",
    /*výhody*/
    faq_0_question_1: "Kolik času ušetřím?",
    faq_0_question_2: "Nemusím si kupovat potraviny navíc?",
    faq_0_question_3: "Nestačí vaše nabídka?",
    faq_0_answer_1: "Až 20 hodin týdně. A to vše proto, že se nebudete muset soustředit na nákupování, vaření, počítaní kalorií a mýtí nádobí. Stačí do fólie propíchnout dírky a ohřat 2-3 minuty v mikrovlnné troubě. Chutné a zdravé jídlo je připravené! Je lepší trávit volný čas s rodinou, povídat si s přáteli, bavit se a rozvíjet se.",
    faq_0_answer_2: "Vaše chladnička bude naplněna až po okraj krabicemi zdravých a chutných potravin. Každé menu je promyšleno šéfkuchařem a vyhovuje výživovým normám.",
    faq_0_answer_3: "Neopakujeme se. Každý den během 3 týdnů jíte něco nového, ale vždy ze svých oblíbených kvalitních a zdravých ingrediencí. Také připravujeme zdravé sladkosti a dezerty. Kromě toho můžete vždy střídat potravinové programy a přizpůsobovat si nabídku podle sebe.</br></br>Budu moci jíst iKitchen na cestách nebo si s sebou vzít oběd do práce?</br></br>Naše nádoby jsou neprodyšně balené a kompaktní. Naše jídla se snadno berou s sebou, jsou vhodná k jídlu i v provozu. Horká jídla budou stále chutná, pokud je předehřejete v mikrovlnné troubě. Je důležité si uvědomit, že v případě delší cesty je nutné přepravovat jídlo v chladničce.",
    /*Jídlo*/
    faq_1_question_1: "Co když mám potravinovou alergii?",
    faq_1_question_2: "BEZ LEPKU",
    faq_1_question_3: "BEZ LAKTÓZY.",
    faq_1_question_4: "Jsou opravdu Vaše jídelníčky vyvážené?",
    faq_1_question_5: "Jaké produkty používáte?",
    faq_1_question_6: "Kde se můžu podívat na jídelníček?",
    faq_1_answer_1: "Pokud máte alergii na určité potraviny, vyberte si této potraviny ze seznamu vyloučení při registraci (nebo později ve Vašem osobním profile v záložce “vyloučení”). Budeme se snažit uvedené potraviny vyměnit za jiné. Avšak upozorňujeme, že se mohou objevit stopy zmíněných produktů z důvodu jejích použití v naší provozně pro jiné klienty.</br></br>Výměna každého produktu je zpoplatněna částkou – 10 - 20 Kč / jeden produkt / den. Výměna mléčných výrobků – 40 Kč / den. Přesná cena je uvedena u konkrétního produktu v seznamu při objednání. Z výrobních důvodů nejsme schopni vyloučit potraviny, které jsou součásti pokrmů jako česnek, bylinky, rajčatový protlak apod. Děkujeme za pochopeni.",
    faq_1_answer_2: "Jídla pro naše diety se připravují z bezlepkových surovin.Ale v provozovně se připravují jídla, která obsahují lepek (pro jiné účely než krabičková dieta). Po práci s lepkem se všechno důkladně čistí. Ale může dojít k tomu, že se na některých produktech objeví stopy lepku.",
    faq_1_answer_3: "Každý program můžeme přizpůsobit na verzi “bez laktózy”.V případě výměny mléčných výrobků za rostlinné alternativy účtujeme částku 40 Kč/den.",
    faq_1_answer_4: "Klademe velký důraz na rozmanitost a pestrost našich jídel, abyste dostaly opravdu vyvážené jídlo každý den. Hodnotíme nejenom kalorický příjem, ale i optimální poměr nutričních hodnot pro nejlepší výsledky.V našich jídelníčkách je hodně zeleniny a ovoce pro posílení Vašeho zdraví. Nechybí i zdravé dezerty bez cukru a lepku.",
    faq_1_answer_5: "Používáme kvalitní suroviny bez umělých barviv, konzervačních látek. Veškerá naše jídla neobsahují lepek. Veškeré produkty pochází od ověřených dodavatelů, část produktů kupujeme v bio kvalitě.",
    faq_1_answer_6: "Aktuální jídelníček najdete na našich webových stránkách www.iKitchen.cz. Pokud provedete registraci a přidáte do Košíku příslušný program, zobrazí se v Košíku podrobný jídelníček na vybrané období.</br></br>Pokud již máte zakoupený program, tak jídelníček včetně nutričních hodnot najdete ve Vašem osobním profilu v záložce „Aktivní programy“.",
    /*O nás*/
    faq_2_question_1: "Jaké programy nabízíte?",
    faq_2_answer_1: "<h5><b><u>Balance</u></b></h5> <p>Jedn&aacute; se o klasick&yacute; program, kter&yacute; je vhodn&yacute; pro každ&eacute;ho člověka.</p> <p>Nemus&iacute;te se vzd&aacute;t sv&yacute;ch obl&iacute;ben&yacute;ch produktů. Vyloučili jsme pouze &scaron;kodliv&aacute; barviva, konzervačn&iacute; l&aacute;tky, cukr a lepek!</p> <p>Balance je program, ve kter&eacute;m najdete ve&scaron;ker&eacute; potřebn&eacute; živiny ve spr&aacute;vn&eacute;m poměru a množstv&iacute;. Najdete v něm spoustu zeleniny a ovoce jako zdroj potřebn&yacute;ch vitam&iacute;nů a miner&aacute;l pro pos&iacute;len&iacute; imunity.</p> <p><b><em><u>Na vyž&aacute;d&aacute;n&iacute; můžeme upravit tento program na vegetari&aacute;nsk&yacute;, neboli bez masa.</u></em></b></p> <p><u>Podkategorie programu se l&iacute;&scaron;&iacute; podle denn&iacute;ho kalorick&eacute;ho př&iacute;jmu:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal &ndash; 4 j&iacute;dla denně</p> <p><b>Daily </b>&ndash; 1350-1550 kCal &ndash; 4 j&iacute;dla denně</p> <p><b>Fit </b>&ndash; 1600-1800 kCal &ndash; 5 j&iacute;del denně včetně zdrav&eacute;ho dezertu</p> <p><b>Power </b>&ndash; 1950-2500 kCal &ndash; 5 j&iacute;del denně včetně zdrav&eacute;ho dezertu</p> <h5><b><u>Vege</u></b></h5> <p>Vyv&aacute;žen&aacute; Vegesk&aacute; strava je založena na konzumaci rostlinn&yacute;ch produktů. Ve Va&scaron;em Vege j&iacute;deln&iacute;čku nenajdete maso, ryby a mořsk&eacute; plody, ml&eacute;čn&eacute; v&yacute;robky a vejce.</p> <p><u>Podkategorie programu se l&iacute;&scaron;&iacute; podle denn&iacute;ho kalorick&eacute;ho př&iacute;jmu:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal &ndash; 4 j&iacute;dla denně</p> <p><b>Daily </b>&ndash; 1350-1550 kCal &ndash; 4 j&iacute;dla denně</p> <p><b>Fit </b>&ndash; 1600-1800 kCal &ndash; 5 j&iacute;del denně včetně zdrav&eacute;ho dezertu</p> <p><b>Power </b>&ndash; 1950-2500 kCal &ndash; 5 j&iacute;del denně včetně zdrav&eacute;ho dezertu</p> <h5><b><u>Low Carb</u></b></h5> <p>Low carb j&iacute;deln&iacute;ček obsahuje omezen&eacute; množstv&iacute; sacharidů, vy&scaron;&scaron;&iacute; obsah tuků a b&iacute;lkovin. V současn&eacute; době tato v&yacute;živa je jedn&iacute;m z nej&uacute;činněj&scaron;&iacute;ch způsobů hubnut&iacute;. Low carb vylep&scaron;&iacute; nejenom Va&scaron;&iacute; postavu, ale i n&aacute;ladu, a stane se Va&scaron;im životn&iacute;m stylem. Někteř&iacute; lid&eacute; zapomenou na cukrovku, a někdo začne ch&aacute;pat sv&eacute; tělo a konečně ztrat&iacute; pocit věčn&eacute;ho hladu.</p> <p><u>Podkategorie programu se l&iacute;&scaron;&iacute; podle denn&iacute;ho kalorick&eacute;ho př&iacute;jmu:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal &ndash; 4 j&iacute;dla denně</p> <p><b>Daily </b>&ndash; 1350-1550 kCal &ndash; 4 j&iacute;dla denně</p> <p><b>Fit </b>&ndash; 1600-1800 kCal &ndash; 5 j&iacute;del denně</p> <p><b>Power </b>&ndash; 1950-2500 kCal &ndash; 5 j&iacute;del denně</p> <h5><b><u>Anti-age</u></b></h5> <p>Anti-age je dieta proti st&aacute;rnut&iacute;. J&iacute;deln&iacute;ček obsahuje minim&aacute;ln&iacute; množstv&iacute; masa, ale je bohat&yacute; na zeleninu a ovoce, ryby a mořsk&eacute; plody, ořechy a dal&scaron;&iacute; produkty, kter&eacute; pom&aacute;haj&iacute; prodlužovat ml&aacute;d&iacute;. Doporučujeme si vyzkou&scaron;et tento program po dobu jednoho-dvou měs&iacute;ců jako obnoven&iacute; a omlazen&iacute; Va&scaron;eho organismu. Budete překvapen&iacute;, jak bude vypadat Va&scaron;e pleť a vlasy. Va&scaron;e tělo dostane potřebnou energii.</p> <p><u>Podkategorie programu se l&iacute;&scaron;&iacute; podle denn&iacute;ho kalorick&eacute;ho př&iacute;jmu:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal</p> <p><b>Daily </b>&ndash; 1350-1550 kCal</p> <p><b>Fit </b>&ndash; 1600-1800 kCal</p> <p>Program Anti-age zahrnuje vždy 3 j&iacute;dla denně. Podle pravidel, na kter&yacute;ch je založen&aacute; dieta proti st&aacute;rnut&iacute; totiž mus&iacute; b&yacute;t vět&scaron;&iacute; pauzy mezi konzumacemi j&iacute;del, a nedoporučuj&iacute; se svačiny.</p>",
    /*Doručení a platba*/
    faq_3_question_1: "Jak probíhá doručení?",
    faq_3_question_2: "Dá se stanovit jiné časové rozmezí pro doručení?",
    faq_3_question_3: "Změna adresy doručení",
    faq_3_question_4: "Co když nemůžu převzít jídlo?",
    faq_3_question_5: "Jde přerušit objednaný program na několik dní?",
    faq_3_question_6: "Kolik stojí doprava?",
    faq_3_question_7: "Jakým způsobem můžu zaplatit?",
    faq_3_question_8: "Výměna produktu",
    faq_3_answer_1: "Dodání se provádí v nedělí, úterý, čtvrtek kurýrní službou od 17:00 do 22:00 hodin. V den doručení budete informování prostřednictvím emailu o přesnějším času doručení (2 hodinové časové okno). Jídlo dostáváte vždy na následující 2 dny.",
    faq_3_answer_2: "Můžeme se přizpůsobit v rámcí aktuálních možností (například doručovat po 18-19hod apod). Napište prosíme Vás požadavek do poznámky při objednání nebo ve Vašem osobním profilu.",
    faq_3_answer_3: "Adresu doručení můžete nastavit ve Vašem osobním profilu v záložce „Doručení“. Každý den doručení může mít odlišnou adresu.<i>Je důležité, aby změna adresy v osobním profilu proběhla nejpozději 48 hodin před dnem doručení.</i></br>Pokud potřebujete změnit adresu později, informujte nás o tom písemně odesláním emailové zprávy na info@ikitchen.cz, a to nejméně 24 hodin předem (do 16:00, den před doručením). Ve výjimečných případech můžeme změnit adresu i v den doručení do 12:00. V tomto případě však nejsme schopni garantovat, že dopravce změnu akceptuje.",
    faq_3_answer_4: "V případě zásahu vyšší moci (jste nepřístupní / nezvedali jste telefon / nepožádali jste, aby byl balíček potravin ponechán na klice dveří nebo na recepci předem), bude kurýr moci zůstat na doručovací adrese po dobu nejvýše 15 minut a poté bude muset odejít za jiným klientem.</br></br>V tomto případě bude Zboží doručeno bez osobního předání tzv. „pověšením na kliku“, kdy se má za to, že Kupující Zboží převzal okamžikem uskutečnění neosobního předání. (podrobnějí – viz Obchodní podmínky).</br></br>Kurýr se také po dohodě může vrátit v pozdější hodině, příplatek za tuto službu činí 200 Kč v hotovosti přímo k rukám kurýra. Kurýr má právo odmítnou opětovné doručení, pokud aktuální situace mu to neumožnuje.",
    faq_3_answer_5: "Ano. Změnu rádi provedeme, pokud nás budete informovat minimálně 2 pracovní dny před dnem doručení. Informujte nás o tom písemně odesláním emailové zprávy na info@ikitchen.cz.",
    faq_3_answer_6: "Momentálně máme níže uvedené ceny dopravy:</br> Praha - zdarma.</br> Jiné lokality, které jsou označené na mapě rozvozu: 30 Kč - 100 Kč/den v závislosti na lokalitě. Přesná částka za dopravu se zobrazí automaticky po uvedení adresy doručení. </br> Další lokality mimo mapu rozvozu – cena na vyžádání.",
    faq_3_answer_7: "Nabízíme možnost platby platební kartou online, platební kartou při převzetí, bankovním převodem. </br> </br><b>Platba online platební kartou.</b> </br>Po vytvoření objednávky budete přesměrováni na bezpečnou platební bránu banky, kde zadáte potřebné údaje. Pokud je transakce autorizována, platba proběhne okamžitě. Podporujeme bezpečný protokol 3D Secure. Naši pracovníci nemají přístup k údajům o Vaší kartě, vše je pouze v rukou banky. </br> </br><b>Bankovní převod.</b> </br>Po dokončení objednávky dostanete potvrzovací email obsahující pokyny k platbě. </br> </br><b>Platba při převzetí.</b> </br>Pokud si zvolíte platbu při převzetí, je potřeba uhradit celkovou částku za objednaný program kurýrovi při prvním doručení. Preferujeme platbu kartou, ve výjimečných případěch je možná i platba v hotovosti. </br>V současné době se snažíme vyhnout platbám v hotovosti z hygienických důvodů. Předem děkujeme za pochopení. ", 
    faq_3_answer_8: "Výměna každého produktu je zpoplatněna částkou - 10-20 Kč / jeden produkt / den. Výměna mléčných výrobků - 40 Kč / den. Přesná cena je uvedena u konkrétního produktu v seznamu při objednání.",
    /*Objednávka*/
    faq_4_question_1: "Jak dlouho dopředu musím udělat objednávku?",
    faq_4_question_2: "Jakým způsobem můžu udělat objednávku?",
    faq_4_answer_1: "3 dny před začátkem programu. </br>Pro začátek programu od pondělí – pošlete prosím objednávku nejpozději v pátek do 23.59. </br>Pro začátek programu od středy – pošlete prosím objednávku nejpozději v neděli do 23.59. </br>Pro začátek programu od pátku – pošlete prosím objednávku nejpozději v úterý do 23.59.",
    faq_4_answer_2: "Objednávku poprosíme udělat online na www.iKitchen.cz. Pro objednání je potřeba si vybrat program, počet dnů a porcí. Pro dokončení objednávky je potřeba si vyplnit registrační údaje. Registrací ziskáte osobní profil, ve kterém najdete veškeré aktivní programy včetně jídelníčku a nutričních hodnot. </br> </br>Pokud máte potíže při objednání, stačí nám poslat níže uvedené údaje na emailovou adresu info@iKitchen.cz – provedeme registraci za Vás, a následně pošleme přístupové údaje k Vašemu osobnímu profile (které můžete kdykoliv změnit). </br>Potřebné údaje pro registraci: jméno a příjmení, doručovací adresa a kontaktní telefon, emailová adresa, zvolený program a počet dnů. ",
    /*Skladování a konzumace */
    faq_5_question_1: "Jak se musí skladovat krabičky s jídlem?",
    faq_5_question_2: "Jak se jídlo ohřívá?",
    faq_5_answer_1: "Zboží je dodáváno v chlazeném stavu. Zboží musí být až do jeho konzumace udržováno v chladu při teplotě 2-4 °C.",
    faq_5_answer_2: "Některá naše jídla se konzumují za studená (saláty, dezerty, jogurty apod.). Teplá jídla se ohřívají v mikrovlnné troubě. Do fólie propíchnete dírky a ohřejte 2-3 min při 600-700 W.",
}